module.exports = __webpack_public_path__ + "static/media/logo_atfalouna_learning.bd177d66.png";